<template>
  <div>
      <div class="title"> Infinite Polygons </div>
      <div class="date"> July 7th, 2019 </div>

      <div class="content">
    
        <div style="display: flex; justify-content: center">
        <div id="canvasContainer"></div>
        </div>

        <div style="display: flex; justify-content: center; padding: 5px">
        <button id="rotateButton" class="customButton" style="margin: 5px">Rotate On</button>
        <button id="circleButton" class="customButton" style="margin: 5px">Circles On</button>
        <button id="resetButton" class="customButton" style="margin: 5px">Reset</button>
        <button id="reverseButton" class="customButton" style="margin: 5px">Reverse Pattern</button>
        </div>

        <p>
        Absolutely fascinating. 
        </p>
        <p>
        We stop the pattern above at a polygon with 60 sides, pretty indistinguishable from a regular circle. 
        As we increase the number of sides of the polygon, it becomes closer and closer to a circle. If we consider 
        initial radius of the first circle to be `1`, what does the maximum radius reached by
        the pattern approach? Let `r_n` be the radius of the circumscribed polygon with `n` sides, where `r_3 = 1`. Doing some
        math, we can find out that: 
        </p>
        <p>`r_n = \prod_{k=3}^{n-1} \frac{1}{cos(\frac{\pi}{k})}, n \ge 4`</p>
        <p>The question to ask is what happens as `n \to \infty`? What is `cos(\frac{\pi}{3}) \cdot cos(\frac{\pi}{4}) \cdot cos(\frac{\pi}{5}) ...`?</p>
        <p>I was not able to discover anything more than `R = \lim_{n \to \infty} r_n \approx 8.700036`, which is quite a weird number. 
        I wish I knew the math to find a closed form expression for it; my gut tells me that the Euler Mascheroni constant 
        would appear in the closed form.</p>
        <p>
            I need closure, this is driving me crazy. I hate `8.700036`.
        </p>

      </div>
  </div>
</template>

<script>

export default {
  name: 'InfinitePolygons',
  mounted: () => {
    const script = function (p5) {
        p5.setup = () => {
            window.MathJax.typeset();

            var width = 800;
            var height = width;
            let canvas = p5.createCanvas(width, height);
            canvas.parent("canvasContainer");

            do_js(p5, width, height);
        }
    }

    const P5 = require('p5');
    new P5(script);
  }
}

function do_js(p5, width, height) {

var step = 0;
var total_steps = 10000;
var draw_circle = true;
var is_rotating = false;
var interval = null;
var reverse_pattern = false;

function animation_frame() {
  p5.clear();
  let radius = width / 18;
  if (reverse_pattern)
    radius = width / 2;

  let x = width / 2;
  let y = height / 2;

  p5.noFill();
  p5.smooth();
  p5.strokeWeight(0.5);
  
  if (is_rotating)
    step = (step + 1) % (total_steps / 3);
  
  for (let n = 3; n < 60; n++) {
    if (draw_circle)
      p5.circle(x, y, 2 * radius);

    if (!reverse_pattern)
      radius /= Math.cos(p5.PI / n);
      
    let offset_angle = Math.PI / 2 + (2 * Math.PI * n 
      * step / total_steps);
      ngon(x, y, radius, n, offset_angle);
        
    if (reverse_pattern)
      radius *= Math.cos(p5.PI / n);
  }
}

function ngon(x, y, radius, n, offset_angle = Math.PI / 2) {
  p5.beginShape();

  for (let i = 1; i <= n; i++)
    p5.vertex(
      x + radius * Math.cos(2 * p5.PI * i / n + offset_angle),
      y - radius * Math.sin(2 * p5.PI * i / n + offset_angle),
    );

  p5.endShape(p5.CLOSE);
}

var rotate_button = document.getElementById("rotateButton");
rotate_button.addEventListener("click", () => {
  if (is_rotating) {
    rotate_button.innerHTML = "Rotate Off";
    clearInterval(interval)
  }
  else {
    rotate_button.innerHTML = "Rotate On";
    interval = setInterval(animation_frame, 60);
  }
    
  is_rotating = !is_rotating;
});

var circle_button = document.getElementById("circleButton");
circle_button.addEventListener("click", () => {
  if (draw_circle)
    circle_button.innerHTML = "Circles Off";
  else
    circle_button.innerHTML = "Circles On";
  
  draw_circle = !draw_circle;
  animation_frame();
});

var reset_button = document.getElementById("resetButton");
reset_button.addEventListener("click", () => {
  step = 0;
  animation_frame();
});

var reverse_button = document.getElementById("reverseButton");
reverse_button.addEventListener("click", () => {
  reverse_pattern = !reverse_pattern;
  animation_frame();
});

animation_frame();

}

</script>

<style scoped>

</style>
